import { useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';
import { StarSky } from 'src/components/star-sky';
import { ButtonLink } from 'src/components/button-link';

export function NotFoundView() {
  const { t } = useTranslation('common');

  return (
    <>
      <title>{t('notFound.meta.title')}</title>
      <meta name="robots" content="noindex,follow" />
      <meta name="description" content={t('notFound.meta.description')} />

      <section className="page-hero">
        <StarSky />
        <div className="container">
          <span className="eyebrow">{t('notFound.eyebrow')}</span>
          <h1>{t('notFound.title')}</h1>
          <p className="lead">{t('notFound.lead')}</p>
          <div className="hero-actions centered">
            <ButtonLink withArrow variant="blue" to={paths.home} label={t('notFound.action')} />
          </div>
        </div>
      </section>
    </>
  );
}
